import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin: 20px;
  border-radius: 10px;
  margin-bottom: 50px;
`;

export const Preview = styled.div`
  width: 700px;
  height: 700px;
  display: flex;
`;

export const H2 = styled.h2`
  text-align: center;
  font-size: 40px;
  margin: 50px;
`;
